import 'App.css';
import * as DataFormat from 'Common/Scripts';

const linkFormatter = (cell, row, rowIndex, formatExtraData) => {
	return (
		<button
			aria-label={`Select for more details on Marking Team ${row.markingTeamTitle}`}
			className="btn btn-primary btn-sm"
			style={{ width: '100px' }}
		>
		Select
	</button>
	);
};

const AmendContractTeamColumns = () => [
	{ dataField: 'markingTeamId', text: 'ID', hidden: true },
	{ 
		dataField: 'button', 
		formatter: linkFormatter,
		headerClasses: 'th-select-td',
		classes: 'tr-td-overflow-hide',
		isDummyField: true,
		text: 'Select Team'
	},
	{
		dataField: 'qualificationYear',
		text: 'Year',
		headerClasses: 'th-td-ssx',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'appointmentType',
		text: 'Type',
		sort: true,
		headerClasses: 'th-td-ssx',
		classes: 'tr-td-overflow-hide'
	},
	{
		dataField: 'markingTeamTitle',
		text: 'Marking Team Title',
		sort: true,
		headerClasses: 'th-auto-td'
	},
	{
		dataField: 'markingTeamCode',
		text: 'Code',
		sort: true,
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
	},
	{
		dataField: 'amendmentNumber',
		text: 'Amendment Number',
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		formatter: DataFormat.replaceNullOrZeroWithEmptyString,
		csvFormatter: DataFormat.replaceNullOrZeroWithEmptyString
	},
	{
		dataField: 'amendmentDate',
		text: 'Amendment Date',
		headerClasses: 'th-td-ms',
		classes: 'tr-td-overflow-hide',
		formatter: DataFormat.createTimeInput,
		csvFormatter: DataFormat.createTimeInput
	}
];

export default AmendContractTeamColumns;
